//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uCharts from '@/components/u-charts/u-charts/u-charts.min.js';
import search from '@/components/search/index.vue'
import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
var _self;
	var canvaLineA=null;
	export default {
		data() {
			return {
				cWidth:'',
				cHeight:'',
				pixelRatio:1,
				today:{
					city:'',
					weather:'',
					temp:'',
				},
				loading:false,
				maxArray:[],
				minArray:[],
				maxWeather:0,
				minWeather:0,
				weatherList:[
				]
			}
		},
		components:{
			search
		},
		onLoad() {
			_self = this;
			this.cWidth=uni.upx2px(750);
			this.cHeight=uni.upx2px(400);
			this.init()
			// this.getFuture()
			
		},
		methods: {
			getToday(){
				return this.$ajax({
					url: `/weChat/cms/weather/getSkWeatherAndTodayWeather?cityName=${this.$store.state.cityName}&appid=${this.$store.state.weatherConfig.appid}&sign=${this.$store.state.weatherConfig.sign}`
				})
			},
			getFuture(){
			  return this.$ajax({
					url:`/weChat/cms/weather/getFutureWeather?cityName=${this.$store.state.cityName}&appid=${this.$store.state.weatherConfig.appid}&sign=${this.$store.state.weatherConfig.sign}`
				})
			},
			getWeatherImg (val) {
			  if (/雨/.test(val)) {
			    return require('@/static/service/weather/rainWeather.png')
			  } else if (/晴/.test(val)) {
			    return require('@/static/service/weather/sunnyWeather.png')
			  } else if (/雪/.test(val)) {
			    return require('@/static/service/weather/snowWeather.png')
			  } else if ('浮尘,扬沙,沙尘暴,强沙尘暴'.indexOf(val) > -1) {
			    return require('@/static/service/weather/windWeather.png')
			  } else {
			    return require('@/static/service/weather/cloudyWeather.png')
			  }
			},
			async init(){
				this.loading=true
				let future=await this.getFuture()
				let today= await this.getToday()
				this.loading=false
				if(today.data&&today.data.todayWeather){
					today.data.todayWeather.temp=today.data.skWeather.temp
					this.today=today.data.todayWeather
				}
				future.data.forEach(res=>{
					let weather={
						week:res.week,
						weather:res.weather,
						time:res.date.substr(5,5)
					}
					this.minArray.push(res.temperature.split('℃')[0])
					this.maxArray.push(res.temperature.split('℃')[1].split('~')[1])
					this.weatherList.push(weather)
				})
				this.maxWeather=(parseInt(this.maxArray.sort()[6])+5)
				this.minWeather=(parseInt(this.minArray.sort()[0])-5)
				this.getServerData();
			},
			getServerData(){
				let LineA={categories:[],series:[]};
				//这里我后台返回的是数组，所以用等于，如果您后台返回的是单条数据，需要push进去
				LineA.categories=["2012", "2013", "2014", "2015", "2016", "2017"];
				LineA.series=[{
					"name": "成交量A",
					"color": '#25AAF8',
					"textColor":"#FFF",
					"data": this.maxArray,
					format:(val)=>{return val+"°C"}
				  }, {
					"name": "成交量B",
					"color":"#FEDB18",
					"textColor":"#FFF",
					"data": this.minArray,
					format:(val)=>{return val+"°C"}
				  }]
				_self.showLineA("canvasLineA",LineA);
			},
			showLineA(canvasId,chartData){
				let _this=this
				canvaLineA=new uCharts({
					$this:_self,
					canvasId: canvasId,
					type: 'line',
					fontSize:13,
					legend:{
						show:false,
					},
					dataLabel:true,
					dataPointShape:true,
					dataPointShapeType:'hollow',
					background:'#FFFFFF',
					pixelRatio:_self.pixelRatio,
					categories: chartData.categories,
					series: chartData.series,
					animation: true,					
					xAxis: {
						disabled:true,						
						disableGrid:true,
						type:'category',
						gridColor:'#CCCCCC',
						axisLine:false
					},
					yAxis: {
						disabled:true,
						disableGrid:true,
						gridType:'dash',
						gridColor:'#CCCCCC',
						dashLength:8,
						splitNumber:10,
						min:this.minWeather,
						max:this.maxWeather,
						format:(val)=>{return val.toFixed(0)+'元'}
					},
					width: _self.cWidth*_self.pixelRatio,
					height: _self.cHeight*_self.pixelRatio,
					extra: {
						line:{
							type: 'curve'
						}
					}
				});
			},
			touchLineA(e) {
			},
			nameInput(e){
				this.$store.commit('changeCityName',e.detail.value)
			},
			search(){
				this.weatherList=[]
				this.minArray=[]
				this.maxArray=[]
				this.init()
			}
		}
	}
